import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type DialogMode = 'success' | 'warning' | 'error';

@Component({
  selector: 'app-status-modal',
  templateUrl: './status-modal.component.html',
  styleUrls: ['./status-modal.component.scss'],
})
export class StatusModalComponent {
  @Input() mode: DialogMode = 'warning';
  public message = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { message: string; mode?: DialogMode },
    private dialogRef: MatDialogRef<StatusModalComponent>
  ) {
    this.message = data.message;
    if (data.mode) {
      this.mode = data.mode;
    }
  }

  public close(): void {
    this.dialogRef.close();
  }
}
